import React, { useCallback } from 'react';
import Typography from '@material-ui/core/Typography';
import { AccordionDetails, Grid } from '@material-ui/core'
import { useHistory } from "react-router-dom";

import { News } from '../../utils/services/cache/ClientCache'
import useStyles from '../../styles/components/news/stylesNewsHolder'
import { ConvertDateString } from '../../utils/helpers/dateformat/ConvertDateString'

const NewsHolder = ({ news }) => {
    const classes = useStyles()
    const history = useHistory()
    const handleBody = (size, text) => {
        let result = text.replace(/(<([^>]+)>)/ig, '').trim();
        const arr = (result.split('&nbsp;').join(' ')).split(' ')
        if (arr.length > size) {
            result = arr.slice(0, size).concat(" ...").join(' ')
        }
        return result
    }

    const handleClick = useCallback(() => {
        News.setNewsId(news.id)
        history.push('/NewsDetail')
    }, [])

    return (
        <Grid container classes={{ root: classes.container }}>
            <Grid
                item
                classes={{ root: classes.rootGridImage }}
                container
                justify="center"
                alignItems="flex-start"
            >
                <div className={classes.wrapperImage}>
                    <img src={news.bannerUrl} alt={news.title} />
                </div>
            </Grid>

            <AccordionDetails classes={{ root: classes.rootGridContent }}>
                <Typography className={classes.textEllipsisTitle} classes={{ root: classes.textTitle }} onClick={handleClick}> {handleBody(10, news.title)} </Typography>
                <Typography className={classes.textEllipsisDes} classes={{ root: classes.textDescription }}>{handleBody(25, news.body)}</Typography>
                <div style={{ marginTop: '10px' }} />
                {news.updatedDate ?
                    <Typography classes={{ root: classes.textDescription }}>{ConvertDateString.convertForDatePicker(news.updatedDate)}</Typography>
                    :
                    <Typography classes={{ root: classes.textDescription }}>{ConvertDateString.convertForDatePicker(news.createdDate)}</Typography>
                }
            </AccordionDetails>          
        </Grid>
    );
};

export { NewsHolder as default }